import { render, staticRenderFns } from "./roleDetail.vue?vue&type=template&id=33293c9a"
import script from "./roleDetail.vue?vue&type=script&lang=js"
export * from "./roleDetail.vue?vue&type=script&lang=js"
import style0 from "./roleDetail.vue?vue&type=style&index=0&id=33293c9a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "roleDetail.vue"
export default component.exports